<!--生产许可证-->
<template>
  <div>
    <div class="fromDiv">
      <div class="formLine">
        <FromLabel label="生产许可证" :showIcon="true" :fontColor="isUpdate('license_file_name')"></FromLabel>
        <div class="allWidth">
          <Input v-model="production_license.license_file_name" :clearable="!is_readonly" @on-clear="clearUploadFile" readonly class="iviewIptWidth307 clearBtn" placeholder="仅支持jpg.jepg.png.pdf等格式的图片/文件">
            <span slot="append" class="finger">
              <FormUpload :isSupplier="true" label="上传" @get-key="getKey(...arguments, 'license_file_key')" :disabled="is_readonly" :data="data"></FormUpload>
            </span>
          </Input>
          <!-- <span class="lookupImg" @click="openFile">{{ production_license.license_file_name }}</span> -->
          <span class="lookupImg" v-if="production_license.company_name && this.production_license.license_file_key" @click="openFile">{{ production_license.company_name }}-生产许可证</span>
          <span class="lookupImg" v-else-if="!production_license.company_name && this.production_license.license_file_key" @click="openFile">-生产许可证</span>
        </div>
      </div>
      <div class="formLine borderTopNone">
        <FromLabel label="有效期限" :showIcon="true" :fontColor="isUpdate('business_start_date') || isUpdate('business_end_date')"></FromLabel>
        <div class="formFlIpt578 fl">
          <DatePicker type="date" placeholder="请选择" class="iviewIptWidth165" :value="production_license.business_start_date" @on-change="changeTime($event, 1)" :readonly="is_readonly"></DatePicker>
          <span class="afterWords14">至</span>
          <DatePicker type="date" placeholder="请选择" class="iviewIptWidth165" :value="production_license.business_end_date" @on-change="changeTime($event, 2)" :options="options" :readonly="is_readonly"></DatePicker>
        </div>
        <FromLabel label="许可证编号" :showIcon="true" :fontColor="isUpdate('production_license_code')"></FromLabel>
        <div class="formFrIpt fl">
          <i-input placeholder="请输入" class="iviewIptWidth307" v-model="production_license.production_license_code" :readonly="is_readonly"></i-input>
        </div>
      </div>
      <div class="formLine borderTopNone">
        <FromLabel label="企业名称" :showIcon="true" :fontColor="isUpdate('company_name')"></FromLabel>
        <div class="allWidth">
          <i-input placeholder="请输入" class="iviewIptWidth307" :disabled="Boolean(is_approved)" v-model="production_license.company_name" :readonly="is_readonly"></i-input>
        </div>
      </div>
      <div class="formLine borderTopNone">
        <FromLabel label="法人" :showIcon="true" :fontColor="isUpdate('legal_person')"></FromLabel>
        <div class="formFlIpt578 fl">
          <i-input placeholder="请输入" class="iviewIptWidth307" v-model="production_license.legal_person" :readonly="is_readonly"></i-input>
        </div>
        <FromLabel label="企业负责人" :showIcon="true" :fontColor="isUpdate('incharge_person')"></FromLabel>
        <div class="formFrIpt fl">
          <i-input placeholder="请输入" class="iviewIptWidth307" v-model="production_license.incharge_person" :readonly="is_readonly"></i-input>
        </div>
      </div>
      <div class="formLine borderTopNone moreHeight">
        <div class="formLabel fl" :class="{ redColor: isUpdate('production_address') }">
          <div>
            <span class="icon">*</span>
            <span>生产地址</span>
          </div>
        </div>
        <div class="allWidth">
          <i-input type="textarea" :autosize="{ minRows: 2, maxRows: 2 }" maxlength="1000" show-word-limit placeholder="请输入" class="iviewIptWidth1075" v-model="production_license.production_address" :readonly="is_readonly"></i-input>
        </div>
      </div>
      <div class="formLine borderTopNone moreHeight">
        <div class="formLabel fl" :class="{ redColor: isUpdate('residence') }">
          <div>
            <span class="icon">*</span>
            <span>住所</span>
          </div>
        </div>
        <div class="allWidth">
          <i-input type="textarea" :autosize="{ minRows: 2, maxRows: 2 }" maxlength="1000" show-word-limit placeholder="请输入" class="iviewIptWidth1075" v-model="production_license.residence" :readonly="is_readonly"></i-input>
        </div>
      </div>
      <div class="formLine borderTopNone moreHeight">
        <div class="formLabel fl" :class="{ redColor: isUpdate('production_scope') }">
          <div>
            <span class="icon">*</span>
            <span>生产范围</span>
          </div>
        </div>
        <div class="allWidth">
          <i-input type="textarea" :autosize="{ minRows: 2, maxRows: 2 }" maxlength="1000" show-word-limit placeholder="请输入" class="iviewIptWidth1075" v-model="production_license.production_scope" :readonly="is_readonly"></i-input>
        </div>
      </div>
      <div class="formLine borderTopNone">
        <FromLabel label="发证部门" :fontColor="isUpdate('license_department')"></FromLabel>
        <div class="formFlIpt578 fl">
          <i-input placeholder="请输入" class="iviewIptWidth307" v-model="production_license.license_department" :readonly="is_readonly"></i-input>
        </div>
        <FromLabel label="发证日期" :showIcon="true" :fontColor="isUpdate('license_date')"></FromLabel>
        <div class="formFrIpt fl">
          <DatePicker type="date" placeholder="请选择" class="iviewIptWidth307" :value="production_license.license_date" @on-change="changeDate('license_date', $event)" :readonly="is_readonly"></DatePicker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FromLabel from '@/components/formLabel'
import FormUpload from '@/components/formUpload'
export default {
  name: 'productionLicens',
  components: {
    FromLabel,
    FormUpload,
  },
  data() {
    return {
      data: {},
      options: {},
      // 生产许可证
      production_license: {},
    }
  },
  mounted() {
    if (this.$route.query.supplier_id) {
      this.data = {
        supplier_id: this.$route.query.supplier_id,
        table_type: 3,
      }
    } else {
      this.data = {
        table_type: 3,
      }
    }
  },
  props: {
    production_license_props: Object,
    p_near_update_field: Array,
    is_readonly: Boolean || false,
    is_approved: Number,
  },
  watch: {
    // 初始化 production_license 值
    production_license_props: {
      handler(newValue, oldValue) {
        this.production_license = newValue
      },
      deep: true,
      immediate: true,
    },
    // 侦听对象-深度侦听-子传父
    productionLicense: {
      handler(newValue, oldValue) {
        let syncField = []
        // 企业名称
        if (newValue.company_name != oldValue.company_name) {
          syncField = ['company_name', newValue.company_name]
        }
        // 法人
        if (newValue.legal_person != oldValue.legal_person) {
          syncField = ['legal_person', newValue.legal_person]
        }
        // 住所
        if (newValue.residence != oldValue.residence) {
          syncField = ['residence', newValue.residence]
        }
        // 生产地址
        if (newValue.production_address != oldValue.production_address) {
          syncField = ['production_address', newValue.production_address]
        }
        // 生产范围
        if (newValue.production_scope != oldValue.production_scope) {
          syncField = ['production_scope', newValue.production_scope]
        }
        // 企业负责人
        if (newValue.incharge_person != oldValue.incharge_person) {
          syncField = ['incharge_person', newValue.incharge_person]
        }
        this.$emit('information', 'production_license', this.production_license, syncField)
      },
      deep: true,
    },
  },
  // 解决深度监听新旧值打印一样问题
  computed: {
    productionLicense() {
      return JSON.parse(JSON.stringify(this.production_license))
    },
  },
  methods: {
    // 修改的值标红
    isUpdate(field) {
      return this.p_near_update_field.includes(field)
    },
    changeDate(field, e) {
      this.production_license[field] = e
    },
    changeTime(e, num) {
      if (num == 1) {
        let that = this
        this.production_license.business_start_date = e
        if (e > this.production_license.business_end_date) {
          this.production_license.business_end_date = ''
        }
        this.options = {
          disabledDate(date) {
            return date && date.valueOf() < new Date(that.production_license.business_start_date) - 86400000
          },
        }
      } else {
        this.production_license.business_end_date = e
      }
    },
    // 打开上传的文件
    openFile() {
      window.open(this.production_license.license_file_key_url)
    },
    // 清空上传文件
    clearUploadFile() {
      delete this.production_license.license_file_key
    },
    // 获取文件上传成功后的 key 值
    getKey(key, file_name, url, field) {
      if (field === 'license_file_key') {
        this.production_license.license_file_key = key
        this.production_license.license_file_key_url = url
        this.production_license.license_file_name = this.production_license.company_name
      }
    },
  },
}
</script>

<style scoped lang="less">
.lookupImg {
  width: 200px;
}

.clearBtn {
  /deep/.ivu-input-icon {
    position: absolute;
    top: 50%;
    right: 68px;
    transform: translate(50%, -50%);
  }
}

.topDiv {
  height: 36px;
  margin-bottom: 20px;
}

.marginRight10 {
  margin-right: 10px;
}

.tableTitle {
  margin: 17px 0 20px 0;

  .title {
    color: #525b6d;
    font-size: 18px;
    font-weight: 600;
  }
}

.moreHeight {
  height: 100px;
}

.formLabel {
  height: 100px !important;
  line-height: 100px !important;
}
</style>
